export const Colors = {
  primary: '#1a75da', // rgba(26,117,218,1)
  yellow: '#eac700', // rgba(234,199,0,1)
  white: '#ffffff',
  black: '#000000',
};
